import { assertType } from '../assert-type';
import { pipe, Result } from '../functional';
import { Num } from '../num';
import { MutableMap, MutableSet, tp } from '../others';
import { IMap } from './imap';
// copied from node_modules/typescript/lib/lib.es2019.array.d.ts and modified
// type FlatArrayDepth =
//   | 0
//   | 1
//   | 2
//   | 3
//   | 4
//   | 5
//   | 6
//   | 7
//   | 8
//   | 9
//   | 10
//   | 11
//   | 12
//   | 13
//   | 14
//   | 15
//   | 16
//   | 17
//   | 18
//   | 19
//   | 20;
// type FlatArrayDepthOption = [
//   -1,
//   0,
//   1,
//   2,
//   3,
//   4,
//   5,
//   6,
//   7,
//   8,
//   9,
//   10,
//   11,
//   12,
//   13,
//   14,
//   15,
//   16,
//   17,
//   18,
//   19,
//   20
// ];
// type ReadonlyFlatArray<Arr, Depth extends FlatArrayDepth> = {
//   done: Arr;
//   recur: Arr extends readonly (infer InnerArr)[]
//     ? FlatArray<InnerArr, FlatArrayDepthOption[Depth]>
//     : Readonly<Arr>;
// }[Depth extends -1 ? 'done' : 'recur'];
export var IList;
(function (IList) {
    // eslint-disable-next-line no-restricted-globals
    const ArrayFrom = Array.from;
    IList.isArray = (a) => 
    // eslint-disable-next-line no-restricted-globals
    Array.isArray(a);
    IList.isEmpty = (list) => list.length === 0;
    IList.isNonEmpty = (list) => list.length > 0;
    IList.isArrayOfLength1 = (array) => array.length === 1;
    IList.isArrayOfLength2 = (array) => array.length === 2;
    IList.isArrayOfLength3 = (array) => array.length === 3;
    IList.isArrayOfLength4 = (array) => array.length === 4;
    IList.isArrayOfLength5 = (array) => array.length === 5;
    IList.isArrayOfLength6 = (array) => array.length === 6;
    IList.isArrayOfLength1OrMore = (array) => array.length >= 1;
    IList.isArrayOfLength2OrMore = (array) => array.length >= 2;
    IList.isArrayOfLength3OrMore = (array) => array.length >= 3;
    IList.isArrayOfLength4OrMore = (array) => array.length >= 4;
    IList.isArrayOfLength5OrMore = (array) => array.length >= 5;
    IList.isArrayOfLength6OrMore = (array) => array.length >= 6;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    IList.length = (list) => list.length;
    IList.size = IList.length;
    /**
     * Creates an array from an iterable object.
     * @param iterable An iterable object to convert to an array.
     */
    IList.from = ArrayFrom;
    IList.asMut = (list) => list;
    /**
     * Creates an array from an iterable object.
     * @param iterable An iterable object to convert to an array.
     * @param mapfn A mapping function to call on every element of the array.
     * @param thisArg Value of 'this' used to invoke the mapfn.
     */
    IList.fromMapped = ArrayFrom;
    IList.zeros = (len) => !Num.isUint32(len)
        ? Result.err('len should be uint32')
        : // eslint-disable-next-line functional/immutable-data
            Result.ok(ArrayFrom({ length: len }).fill(0));
    IList.zerosThrow = (len) => Result.unwrapThrow(IList.zeros(len));
    IList.seq = (len) => pipe(IList.zeros(len)).chain(Result.map((l) => l.map((_, i) => i))).value;
    IList.seqThrow = (len) => Result.unwrapThrow(IList.seq(len));
    IList.newArray = (len, init) => pipe(IList.zeros(len)).chain(Result.map((l) => l.map(() => init))).value;
    IList.newArrayThrow = (len, init) => Result.unwrapThrow(IList.newArray(len, init));
    IList.range = (start, end, step = 1) => pipe(IList.seq(end - start)).chain(Result.map((l) => l.map((n) => n * step + start))).value;
    IList.rangeThrow = (start, end, step = 1) => Result.unwrapThrow(IList.range(start, end, step));
    IList.copy = (list) => list.slice();
    {
        const ar = [1, 2, 3];
        const ar2 = IList.copy(ar);
        assertType();
    }
    IList.slice = (list, start, end) => {
        const startClamped = Num.clamp(0, list.length)(start);
        const endClamped = Num.clamp(startClamped, list.length)(end);
        return list.slice(startClamped, endClamped);
    };
    function head(list) {
        return IList.isEmpty(list) ? undefined : list[0];
    }
    IList.head = head;
    IList.first = head;
    function last(list) {
        return IList.isEmpty(list) ? undefined : list[list.length - 1];
    }
    IList.last = last;
    IList.tail = (list) => list.slice(1);
    IList.rest = IList.tail;
    IList.shift = IList.tail;
    IList.butLast = (list) => (IList.isEmpty(list) ? [] : list.slice(0, -1));
    IList.take = (list, num) => IList.slice(list, 0, num);
    IList.takeLast = (list, num) => IList.slice(list, IList.size(list) - num, IList.size(list));
    IList.skip = (list, num) => IList.slice(list, num, IList.size(list));
    IList.skipLast = (list, num) => IList.slice(list, 0, IList.size(list) - num);
    IList.pop = IList.butLast;
    function every(list, predicate) {
        return list.every(predicate);
    }
    IList.every = every;
    IList.some = (list, predicate) => list.some(predicate);
    IList.map = (list, mapFn) => list.map(mapFn);
    // TODO: support tuple type
    IList.flat = (list, depth = 1) => list.flat(depth);
    IList.flatMap = (list, mapper) => list.flatMap(mapper);
    // // TODO: add an overload of NonEmpty case
    IList.zip = (list1, list2) => {
        const len = Math.min(list1.length, list2.length);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return IList.seqThrow(len).map((i) => tp(list1[i], list2[i]));
    };
    function filter(list, predicate) {
        return list.filter(predicate);
    }
    IList.filter = filter;
    {
        const a = [1, 2, 3];
        const r = filter(a, (x) => x === 1);
        assertType();
    }
    IList.filterNot = (list, predicate) => list.filter((a, i) => !predicate(a, i));
    // TODO: improve type
    IList.set = (list, index, newValue) => IList.map(list, (a, i) => (i === index ? newValue : a));
    // TODO: improve type
    IList.update = (list, index, updater) => IList.map(list, (a, i) => (i === index ? updater(a) : a));
    // TODO: improve type
    IList.insert = (list, index, newValue) => {
        const mut_temp = ArrayFrom(list);
        mut_temp.splice(index, 0, newValue);
        return mut_temp;
    };
    IList.remove = (list, index) => {
        // eslint-disable-next-line no-restricted-globals
        const mut_temp = ArrayFrom(list);
        mut_temp.splice(index, 1);
        return mut_temp;
    };
    IList.push = (list, value) => [...list, value];
    IList.unshift = (list, value) => [value, ...list];
    IList.concat = (list1, list2) => [...list1, ...list2];
    IList.partition = (list, n) => IList.seqThrow(Math.ceil(list.length / n)).map((i) => list.slice(n * i, n * (i + 1)));
    IList.reverse = (list) => 
    // eslint-disable-next-line functional/immutable-data
    ArrayFrom(list).reverse();
    function sort(list, comparator) {
        const cmp = comparator !== null && comparator !== void 0 ? comparator : ((x, y) => x - y);
        // eslint-disable-next-line functional/immutable-data
        return ArrayFrom(list).sort(cmp);
    }
    IList.sort = sort;
    function sortBy(list, comparatorValueMapper, comparator) {
        return sort(list, (x, y) => comparator === undefined
            ? comparatorValueMapper(x) -
                comparatorValueMapper(y)
            : comparator(comparatorValueMapper(x), comparatorValueMapper(y)));
    }
    IList.sortBy = sortBy;
    IList.includes = (list, searchElement) => list.includes(searchElement);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    IList.find = (list, predicate) => list.find(predicate);
    function min(list, comparator) {
        const cmp = comparator !== null && comparator !== void 0 ? comparator : ((x, y) => x - y);
        return IList.isEmpty(list)
            ? undefined
            : list.reduce((mx, curr) => (cmp(mx, curr) < 0 ? mx : curr), list[0]);
    }
    IList.min = min;
    function max(list, comparator) {
        const cmp = comparator !== null && comparator !== void 0 ? comparator : ((x, y) => x - y);
        return min(list, (x, y) => -cmp(x, y));
    }
    IList.max = max;
    function minBy(list, comparatorValueMapper, comparator) {
        return min(list, (x, y) => comparator === undefined
            ? comparatorValueMapper(x) -
                comparatorValueMapper(y)
            : comparator(comparatorValueMapper(x), comparatorValueMapper(y)));
    }
    IList.minBy = minBy;
    function maxBy(list, comparatorValueMapper, comparator) {
        return max(list, (x, y) => comparator === undefined
            ? comparatorValueMapper(x) -
                comparatorValueMapper(y)
            : comparator(comparatorValueMapper(x), comparatorValueMapper(y)));
    }
    IList.maxBy = maxBy;
    IList.sum = (list) => list.reduce((prev, curr) => prev + curr, 0);
    IList.foldl = (list, callbackfn, initialValue) => list.reduce(callbackfn, initialValue);
    IList.reduce = IList.foldl;
    IList.foldr = (list, callbackfn, initialValue) => list.reduceRight(callbackfn, initialValue);
    IList.reduceRight = IList.foldr;
    IList.scan = (list, reducer, init) => {
        const mut_result = ArrayFrom(IList.newArrayThrow(list.length + 1, init));
        let mut_acc = init;
        for (const [index, value] of list.entries()) {
            mut_acc = reducer(mut_acc, value);
            mut_result[index + 1] = mut_acc;
        }
        return mut_result;
    };
    IList.count = (list, predicate = () => true) => list.reduce((acc, curr, index) => (predicate(curr, index) ? acc + 1 : acc), 0);
    IList.countBy = (list, grouper) => {
        var _a;
        const groups = new MutableMap();
        for (const [index, e] of list.entries()) {
            const key = grouper(e, index);
            const curr = (_a = groups.get(key)) !== null && _a !== void 0 ? _a : 0;
            groups.set(key, curr + 1);
        }
        return IMap.new(groups);
    };
    IList.groupBy = (list, grouper) => {
        const mut_groups = new MutableMap();
        for (const [index, e] of list.entries()) {
            const key = grouper(e, index);
            if (mut_groups.has(key)) {
                const mut_g = mut_groups.get(key);
                mut_g === null || mut_g === void 0 ? void 0 : mut_g.push(e);
            }
            else {
                mut_groups.set(key, [e]);
            }
        }
        return IMap.new(mut_groups);
    };
    function uniq(list) {
        return ArrayFrom(new MutableSet(list));
    }
    IList.uniq = uniq;
    function uniqBy(list, mapFn) {
        const mappedValues = new MutableSet();
        return list.filter((val) => {
            const mappedValue = mapFn(val);
            if (mappedValues.has(mappedValue))
                return false;
            mappedValues.add(mappedValue);
            return true;
        });
    }
    IList.uniqBy = uniqBy;
    IList.indexIsInRange = (list, index) => Num.isUint32(index) && 0 <= index && index < list.length;
    IList.eq = (list1, list2) => list1.length === list2.length && list1.every((v, i) => v === list2[i]);
    /** @returns list1 ⊂ list2 */
    IList.isSubset = (list1, list2) => list1.every((a) => list2.includes(a));
    /** @returns list1 ⊃ list2 */
    IList.isSuperset = (list1, list2) => IList.isSubset(list2, list1);
    IList.setIntersection = (list1, list2) => list1.filter((e) => list2.includes(e));
    IList.setDifference = (list1, list2) => list1.filter((e) => !list2.includes(e));
    IList.sortedNumSetDifference = (sortedList1, sortedList2) => {
        const mut_result = [];
        let mut_it1 = 0; // iterator for sortedArray1
        let mut_it2 = 0; // iterator for sortedArray2
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        let mut_val1 = sortedList1[mut_it1];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        let mut_val2 = sortedList2[mut_it2];
        while (mut_it1 < sortedList1.length && mut_it2 < sortedList2.length) {
            if (mut_val1 === mut_val2) {
                mut_it1 += 1;
                mut_it2 += 1;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mut_val1 = sortedList1[mut_it1];
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mut_val2 = sortedList2[mut_it2];
            }
            else if (mut_val1 < mut_val2) {
                mut_result.push(mut_val1);
                mut_it1 += 1;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mut_val1 = sortedList1[mut_it1];
            }
            else {
                mut_it2 += 1;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mut_val2 = sortedList2[mut_it2];
            }
        }
        for (; mut_it1 < sortedList1.length; mut_it1 += 1) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            mut_result.push(sortedList1[mut_it1]);
        }
        return mut_result;
    };
})(IList || (IList = {}));
